import { useNodeConnections } from '@xyflow/react';
import { AgentPrimitive } from './primitive';
import { AgentTransform } from './transform';

export interface AgentNodeData extends Record<string, unknown> {
  label?: string;
  systemPrompt?: string;
  llmApiKey?: string;
  composioApiKey?: string;
  allowedTools?: string;
  agentRole?: string;
  generated?: {
    result?: string;
    status?: string;
    error?: string;
  };
  model?: string;
  updatedAt?: string;
}

export interface AgentNodeProps {
  type: string;
  data: AgentNodeData;
  id: string;
}

export const AgentNode = (props: AgentNodeProps) => {
  const connections = useNodeConnections({
    id: props.id,
    handleType: 'target',
  });

  const Component = connections.length ? AgentTransform : AgentPrimitive;

  return <Component {...props} title="Agent" />;
};
